import React from 'react';

export const Disclaimer: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Disclaimer</h1>
      <div className="prose prose-blue max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Medical Disclaimer</h2>
          <div className="space-y-4">
            <p>
              <strong className="text-red-600">FOR RESEARCH PURPOSES ONLY!</strong> The Peptide Now 
              Precision Vial Metrics Calculator and all information provided through this website are 
              strictly for research and educational purposes only. None of the information or 
              calculations are intended for use on humans.
            </p>
            <p>
              This calculator is not intended to:
            </p>
            <ul className="list-disc pl-6">
              <li>Provide medical advice or treatment recommendations</li>
              <li>Diagnose, treat, cure, or prevent any disease or medical condition</li>
              <li>Replace consultation with qualified healthcare professionals</li>
              <li>Suggest or recommend any form of human consumption or application</li>
              <li>Provide dosing guidelines for any substance</li>
            </ul>
            <p>
              The calculations provided are mathematical conversions only and should not be interpreted 
              as recommendations for any form of medical treatment or human use. Any person viewing this 
              information acknowledges that they are doing so for research purposes only.
            </p>
            <p>
              If you have a medical condition or health concern, always consult with a qualified 
              healthcare provider. Do not disregard professional medical advice or delay seeking it 
              based on any information or calculations provided by this tool.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Legal Disclaimer</h2>
          <div className="space-y-4">
            <p>
              The information and calculations provided by Peptide Now are offered "as is" without any 
              warranties, expressed or implied. We make no representations or warranties regarding the 
              accuracy, completeness, or reliability of any information provided.
            </p>
            <p>
              By using this calculator, you acknowledge and agree that:
            </p>
            <ul className="list-disc pl-6">
              <li>All calculations are provided for research purposes only</li>
              <li>No information constitutes professional advice of any kind</li>
              <li>You assume all risk and responsibility for the use of this calculator</li>
              <li>Peptide Now is not liable for any damages arising from the use of this tool</li>
              <li>You will not use the information for any purpose prohibited by law</li>
            </ul>
            <p>
              This disclaimer may be updated without notice. Your continued use of the calculator 
              constitutes acceptance of any modifications to this disclaimer.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};